<app-select (selection)="selection($event)" *ngIf="choices.length > 0" [choices]="choices"></app-select>
